import { render } from "./CartShipment.vue?vue&type=template&id=01246b58"
import script from "./CartShipment.vue?vue&type=script&lang=js"
export * from "./CartShipment.vue?vue&type=script&lang=js"

import exportComponent from "/Users/macmini/Sites/self-ship/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__